export default __webpack_public_path__ + "static/media/entradageneral_registro_verde.384b86ed.png";